import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LogService } from '../log/log.service';
import { AuthenticationStore } from '../../permission/services/authentication.store';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class CanActivateViaAuthGuard implements CanActivate {

  constructor(private router: Router,
              private authService: AuthenticationStore,
              private logService: LogService) {
  }

  canActivate(): Observable<boolean> {
    return this.authService.isLoggedIn().map(isLoggedIn => {
      this.logService.debug(`isAuthenticated ${isLoggedIn}`);
      if (!isLoggedIn) {
        if (this.authService.isExternalLogin()) {
          this.router.navigate([ '/external-login-expired' ]);
        } else {
          this.router.navigate([ '/login' ]);
        }
      }
      return isLoggedIn;
    });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/guards/can-activate-via-auth-guard.ts